import { ref, onMounted } from 'vue'

const DISMISS_KEY = 'pwa-update-dismissed'

const needRefresh = ref(false)
let updateSW: (() => Promise<void>) | null = null

export function usePWAUpdate() {
  onMounted(async () => {
    if (!('serviceWorker' in navigator)) return

    const { registerSW } = await import('virtual:pwa-register')
    updateSW = registerSW({
      onNeedRefresh() {
        if (localStorage.getItem(DISMISS_KEY)) return
        needRefresh.value = true
      },
      onOfflineReady() {
        // SW ready for offline use
      }
    })
  })

  async function applyUpdate() {
    if (updateSW) {
      await updateSW()
      needRefresh.value = false
      localStorage.removeItem(DISMISS_KEY)
    }
  }

  function dismiss() {
    needRefresh.value = false
    localStorage.setItem(DISMISS_KEY, '1')
  }

  return { needRefresh, applyUpdate, dismiss }
}
